import { getType } from 'typesafe-actions';

import { setCurrentGame } from '../actions/game';
import { resetLastPanoramaPlace, setLastPanoramaPlace } from '../actions/pano';

const initialState = {
    lat: null,
    lon: null,
};

const panoramaReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(setLastPanoramaPlace): {
            const { lat, lon } = action.payload;
            return {
                ...state,
                lat,
                lon,
            };
        }
        case getType(resetLastPanoramaPlace): {
            return initialState;
        }
        case getType(setCurrentGame): {
            // `pano` is persisted so a player can resume an active round after a
            // reload. It must not, however, leak the final position into a newly
            // started game. GuessResultMode.end would then score the first round
            // against the previous game's last panorama position.
            return action.payload?.round === 1 ? initialState : state;
        }
        default:
            return state;
    }
};

export default panoramaReducer;
